/**
 * 檔案用途區塊
 * @module GoogleLogin
 * @purpose 負責進入 Google 第三方登入流程時，依 provider payload 組出 SSO 授權網址並立即導向。
 * @external https://innotech.atlassian.net/browse/IN-94351
 * @external https://innotech.atlassian.net/browse/IN-54205
 * @external https://innotech.atlassian.net/browse/IN-52139
 * @external https://innotech.atlassian.net/browse/IN-52157
 * @external https://innotech.atlassian.net/browse/IN-47655
 */
import React, { useEffect } from 'react';
import { useThirdPartyProvider } from '@shared/models';
import { Page } from '@shared/enums/route.enum';
import { getSsoUrl } from '@utilities/helpers/ssoUrl.helper';

/**
 * 宣告內容用途說明與單號關聯
 * @description Google 登入頁元件，掛載後即觸發登入導向。
 * @purpose 作為 Google SSO redirect 型登入的進入點，避免停留中間頁。
 * @external https://innotech.atlassian.net/browse/IN-47655
 */
const GoogleLogin = () => {
  /**
   * 宣告內容用途說明與單號關聯
   * @description 取得第三方登入流程預先注入的 clientId 與 redirectUrl 等參數。
   * @purpose 提供組裝 Google SSO 授權網址所需的 payload 資料來源。
   * @external https://innotech.atlassian.net/browse/IN-47655
   */
  const { payload } = useThirdPartyProvider();

  /**
   * 宣告內容用途說明與單號關聯
   * @description 依 payload 參數產生 Google SSO URL，並以 location.replace 導向。
   * @purpose 以 URL 授權流程取代 SDK 觸發，統一路由導向與登入啟動方式。
   * @external https://innotech.atlassian.net/browse/IN-94351
   */
  const login = () => {
    location.replace(
      getSsoUrl(Page.Google, {
        clientId: payload.clientId!,
        redirectUrl: payload.redirectUrl!,
      }),
    );
  };

  useEffect(() => login());

  return <></>;
};

export default GoogleLogin;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:11:22.085Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout (top/middle/bottom), inserted declaration-level JSDoc blocks using only mapped origin tickets, formatted all @external values as full Jira browse URLs, and kept runtime logic unchanged.
 */
